import { createTheme } from '@mui/material/styles';
import { baseTheme } from './base';

interface MuiAutocompleteThemeProps {
  width?: number;
  multiple?: boolean;
  fullWidth?: boolean;
  disableGroupSticky?: boolean;
  height?: string;
}

export function createMuiAutocompleteTheme({
  width,
  multiple,
  fullWidth,
  disableGroupSticky,
  height = '38px',
}: MuiAutocompleteThemeProps) {
  return createTheme({
    palette: baseTheme.palette,
    components: {
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            width: fullWidth ? '100%' : 200,

            '& .MuiOutlinedInput-root': {
              height: height,
              padding: '0px 14px',
            },

            '& .MuiInputLabel-root': {
              transform: 'translate(14px, 8px) scale(1)!important',
              transition: 'transform 0.2s ease-in-out',
            },

            '& .MuiInputLabel-shrink': {
              transform: 'translate(14px, -6px) scale(0.75)!important',
            },

            '& .MuiInputBase-root.MuiAutocomplete-inputRoot': {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              alignContent: 'flex-start',
            },

            '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
              width: multiple ? 'auto' : '100%',
              paddingLeft: '0!important',
            },

            '& .MuiAutocomplete-input.MuiInputBase-inputAdornedStart.MuiInputBase-inputAdornedEnd::placeholder':
              {
                opacity: 0, // Only the placeholder is invisible
              },

            '& .MuiSvgIcon-root': {
              color: baseTheme.palette.primary.main,
              opacity: 0.87,
            },

            '& .MuiFormLabel-root': {
              color: baseTheme.palette.text.secondary,
            },

            '& .MuiCircularProgress-root': {
              zIndex: 1,
              backgroundColor: 'white',
              position: ' absolute',
              right: '12px',
            },
          },
          option: {
            '&:hover': {
              backgroundColor: baseTheme.palette.grey['200'],
            },
          },
        },
      },

      MuiPopper: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
            zIndex: '999999 !important',

            '& .MuiPaper-root': {
              width: `${width}px`,
              boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
              ...(!disableGroupSticky && {
                '& .MuiAutocomplete-listbox.css-kuz6fl-MuiAutocomplete-listbox':
                  {
                    padding: '0px !important',
                  },
              }),
            },

            '& ::-webkit-scrollbar': {
              width: '8px!important',
              height: '8px!important',
            },

            '& ::-webkit-scrollbar-track': {
              background: 'transparent',
            },

            '& ::-webkit-scrollbar-thumb': {
              borderRadius: '4px',
              background: baseTheme.palette.grey['400'],
            },

            '& li': {
              fontSize: 14,

              '& .MuiCheckbox-root': {
                padding: '5px',
                paddingLeft: '0',

                '&:hover': {
                  backgroundColor: 'transparent',
                },
              },
            },
            '& .MuiAutocomplete-option': {
              paddingTop: '10px !important',
              paddingBottom: '10px !important',
            },
          },
        },
      },
    },
  });
}
